import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal } from 'antd'

@inject((store: any) => {
    const { popupStore } = store
    return {
        popupStore
    }
})
@observer
export default class ChooseFilePopup extends Component<any, any> {
    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore } = this.props
        const { info, popupType } = popupStore
        return (
            <Modal title={info.title} visible={popupType === 'clarification'} onCancel={this.closePopup} footer={null}>
                <div style={{ maxHeight: '70vh', overflow: 'overlay' }}>
                    {info.rights && info.rights.map(right => <div>{right.name}</div>)}
                </div>
            </Modal>
        )
    }
}
